module.exports = __webpack_public_path__ + "static/img/MadLibs.5b44550.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assignments/java/images/MadLibs.jpg
// module id = A04U
// module chunks = 1